<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data UserPic" subTitle="Forms" />

    <ListUserPic />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListUserPic from "@/components/Pages/Data/UserPic/ListUserPic.vue";

export default defineComponent({
  name: "ListUserPicPage",
  components: {
    PageTitle,
    ListUserPic,
  },
});
</script>
